import { useLocaleData, useT } from "../../i18n/useT";
import React from "react";

const Skills = () => {
  const t = useT();
  const columns = useLocaleData("sections.skills.columns") || [];
  return (
    <section className="p-3 p-lg-5 d-flex flex-column" id="skills">
      <h1 className="text-uppercase mb-4">{t("sections.skills.title")}</h1>
      <div className="row my-4">
        {columns.map((column, colIdx) => (
          <div key={colIdx} className="col-xs-12 col-md-6">
            {(column.categories || []).map((category, catIdx) => (
              <React.Fragment key={catIdx}>
                <h4 className="text-uppercase">{category.name}</h4>
                <ul className="list-inline ml-4 text-muted">
                  {(category.items || []).map((item, itemIdx) => (
                    <li
                      key={itemIdx}
                      className="d-flex justify-content-between"
                    >
                      <span>
                        <i className="fa fa-caret-right mr-3"></i>
                        {item.name}
                      </span>
                      {typeof item.stars === "number" && (
                        <span>
                          {Array.from({ length: 5 }).map((_, i) => (
                            <i
                              key={i}
                              className={
                                i < item.stars ? "fa fa-star" : "fa fa-star-o"
                              }
                            ></i>
                          ))}
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              </React.Fragment>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
